import { put, call, fork, takeLatest } from 'redux-saga/effects'
import apiClient from 'admin/api/apiClient'
import { notifyError, notifySuccess } from 'shared/sharedMethod'

// Actions
export const actionTypes = {
  CREATE_POS_SALE: 'posSale/CREATE_POS_SALE',
  FETCH_POS_SALES: 'posSale/FETCH_POS_SALES',
  FETCH_POS_SALE: 'posSale/FETCH_POS_SALE',
  UPADE_POS_SALE: 'posSale/UPADE_POS_SALE',
  DELETE_POS_SALE: 'posSale/DELETE_POS_SALE',

  POS_SALE_CREATED: 'posSale/POS_SALE_CREATED',
  POS_SALES_LOADED: 'posSale/POS_SALES_LOADED',
  POS_SALE_LOADED: 'posSale/POS_SALE_LOADED',
  POS_SALE_UPDATED: 'posSale/POS_SALE_UPDATED',
  POS_SALE_DELETED: 'posSale/POS_SALE_DELETED'
}

const initialState = {
  posSale: null,
  posSales: null
}

// Reducer
export function reducer (state = initialState, action) {
  switch (action.type) {
    case actionTypes.CREATE_POS_SALE:
      return { ...state, posSale: action.payload }
    case actionTypes.FETCH_POS_SALES:
      return { ...state, posSales: null }
    case actionTypes.FETCH_POS_SALE:
      return { ...state, posSale: null }
    case actionTypes.UPADE_POS_SALE:
      return { ...state, posSale: action.payload }
    case actionTypes.DELETE_POS_SALE:
      return state

    case actionTypes.POS_SALE_CREATED:
      return { ...state, posSales: [...state.posSales, action.payload] }
    case actionTypes.POS_SALES_LOADED:
      return { ...state, posSales: action.payload }
    case actionTypes.POS_SALE_LOADED:
      return { ...state, posSale: action.payload }
    case actionTypes.POS_SALE_UPDATED:
      return {
        ...state,
        posSale: action.payload,
        posSales: state.posSales.map(item => item.id === +action.payload.id ? action.payload : item)
      }
    case actionTypes.POS_SALE_DELETED:
      return { ...state, posSales: state.posSales.filter(item => item.id !== action.payload) }

    default:
      return state
  }
}

// Action Creators
export const actions = {
  createPosSale: (posSale, setSubmitting) => ({ type: actionTypes.CREATE_POS_SALE, payload: { posSale, setSubmitting } }),
  fetchPosSales: () => ({ type: actionTypes.FETCH_POS_SALES }),
  fetchPosSale: (id) => ({ type: actionTypes.FETCH_POS_SALE, payload: id }),
  updatePosSale: (posSale, setSubmitting) => ({ type: actionTypes.UPADE_POS_SALE, payload: { posSale, setSubmitting } }),
  deletePosSale: id => ({ type: actionTypes.DELETE_POS_SALE, payload: id }),
  posSaleCreated: (posSale) => ({ type: actionTypes.POS_SALE_CREATED, payload: posSale }),
  posSalesLoaded: (posSales) => ({ type: actionTypes.POS_SALES_LOADED, payload: posSales }),
  posSaleLoaded: (posSale) => ({ type: actionTypes.POS_SALE_LOADED, payload: posSale }),
  posSaleUpdated: (posSale) => ({ type: actionTypes.POS_SALE_UPDATED, payload: posSale }),
  posSaleDeleted: id => ({ type: actionTypes.POS_SALE_DELETED, payload: id })
}

// Saga
export function * saga () {
  yield takeLatest(actionTypes.CREATE_POS_SALE, function * createPosSaleSaga (action) {
    const { posSale, setSubmitting } = action.payload
    try {
      const result = yield call(apiClient.post, 'pos_sales', posSale)
      yield put(actions.posSaleCreated(result.data.data))
      notifySuccess('新增成功')
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    } finally {
      setSubmitting(false)
    }
  })

  yield takeLatest(actionTypes.FETCH_POS_SALES, function * fetchPosSalesSaga () {
    try {
      const result = yield call(apiClient.get, 'pos_sales')
      yield put(actions.posSalesLoaded(result.data.data))
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })

  yield takeLatest(actionTypes.FETCH_POS_SALE, function * fetchPosSaleSaga (action) {
    try {
      const id = action.payload
      const result = yield call(apiClient.get, `pos_sales/${id}`)
      yield put(actions.posSaleLoaded(result.data.data))
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })

  yield takeLatest(actionTypes.UPADE_POS_SALE, function * updatePosSaleSaga (action) {
    const { posSale, setSubmitting } = action.payload
    try {
      const result = yield call(apiClient.put, `pos_sales/${posSale.id}`, posSale)
      yield put(actions.posSaleUpdated(result.data.data))
      notifySuccess('更新成功')
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    } finally {
      setSubmitting(false)
    }
  })

  yield takeLatest(actionTypes.DELETE_POS_SALE, function * deletePosSaleSaga (action) {
    try {
      const id = action.payload
      yield fork(apiClient.delete, `pos_sales/${id}`)
      yield put(actions.posSaleDeleted(id))
      notifySuccess('刪除成功')
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })
}
